import { render } from "./person-create-import.vue?vue&type=template&id=286c801b"
import script from "./person-create-import.vue?vue&type=script&lang=js"
export * from "./person-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__